import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconInfoCircle } from '#src/atoms/icons/system/iconInfoCircle.ts';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

import { CryptoBalance } from './CryptoBalance/index.tsx';
import { Deposit } from './Deposit/index.tsx';
import { FiatBalance } from './FiatBalance/index.tsx';

const Root = styled(Vertical).attrs({ gap: 0 })`
  border: 1px solid var(--c-nd-150);
  border-radius: var(--unit);
`;
const MigrationWarning = styled.div`
  padding: var(--unit);
  border-top: 1px solid var(--c-nd-150);
`;
const StyledHorizontal = styled(Horizontal).attrs({ gap: 0 })`
  border-bottom: 1px solid var(--c-nd-150);
  & > * {
    flex: 1;
    padding: var(--unit);
    text-align: center;
  }
  .sidebarCollapsed & {
    flex-direction: column;

    & > * {
      width: 100%;
      padding: var(--unit) var(--half-unit);
    }

    & > :first-child {
      border-bottom: 1px solid var(--c-nd-150);
      border-right: none;
    }
  }

  & > :first-child {
    border-right: 1px solid var(--c-nd-150);
  }
  &:hover {
    background-color: var(--c-nd-50);
  }

  transition:
    300ms background-color ease-in-out,
    300ms color ease-in-out,
    300ms border-color ease-in-out;
`;

type Props = { onClick?: () => void; sidebarCollapsed?: boolean };
export const MoneyBalances = ({ onClick, sidebarCollapsed }: Props) => {
  const isLaptop = useIsLaptop();
  const {
    currentUser,
    walletPreferences: { showCryptoWallet },
  } = useCurrentUserContext();
  const shouldMigrateEth = !!currentUser?.shouldMigrateEth;

  return (
    <Root>
      <StyledHorizontal>
        <button onClick={onClick} type="button">
          <FiatBalance collapsed={sidebarCollapsed} />
        </button>
        {!!showCryptoWallet && (
          <button onClick={onClick} type="button">
            <CryptoBalance collapsed={sidebarCollapsed} />
          </button>
        )}
      </StyledHorizontal>
      {!!shouldMigrateEth && !sidebarCollapsed && (
        <MigrationWarning>
          <Button
            fullWidth
            color="red"
            size={isLaptop ? 'compact' : 'small'}
            startIcon={<FontAwesomeIcon icon={iconInfoCircle} />}
            onClick={onClick}
          >
            <FormattedMessage defaultMessage="Migrate ETH" />
          </Button>
        </MigrationWarning>
      )}
      <Deposit onClick={onClick} sidebarCollapsed={sidebarCollapsed} />
    </Root>
  );
};
